<template>
  <div class="choice-test">
    <div class="main-options" v-if="test.options && test.options.length">
      <div class="option-title">请根据以下选项回答问题</div>
      <div class="options-list">
        <div v-for="(option, index) in test.options" :key="option.id" class="option-item">
          <span class="option-letter">{{ getOptionLetter(index) }}.</span>
          <span class="option-content" v-html="convertTestText(option.content)"></span>
        </div>
      </div>
    </div>

    <div class="subtests-list" v-if="test.subtests && test.subtests.length">
      <div v-for="(subtest, subIndex) in test.subtests" :key="subtest.id" class="subtest-item">
        <div class="subtest-title">
          ({{ subIndex + 1 }}). <span v-html="convertTestText(subtest.title)"></span>
        </div>
        <div class="subtest-answer">
          <span class="answer-label">请选择答案：</span>
          <div class="answer-options">
            <div v-for="(option, optIndex) in (test.options || [])" :key="option.id" class="answer-option"
              :class="{ active: subtestAnswers[subtest.id] === getOptionLetter(optIndex) }"
              @click="selectOption(subtest, optIndex)">
              <span class="radio-circle"
                :class="{ checked: subtestAnswers[subtest.id] === getOptionLetter(optIndex) }"></span>
              <span class="radio-letter">{{ getOptionLetter(optIndex) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <answer :test="test" v-if="test.subtest"></answer>
    <!-- <div class="submit-btn-wrapper">
      <button class="submit-btn" @click="submitAnswer">提交</button>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'choice-test',
  props: {
    test: {
      type: Object,
      default: () => ({})
    },
    testId: {
      type: Number,
      default: null
    },
    choiceAnswer: {
      type: String,
      default: ''
    },
    tempResult: {
      type: String,
      default: ''
    },
    showAnswer: { // 是否显示答案
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      subtestAnswers: {} // 存储每个子题目的答案 { subtestId: 'A' }
    }
  },
  created() {
    this.initAnswers()
  },
  watch: {
    test: {
      handler() {
        this.initAnswers()
      },
      deep: true
    },
    tempResult: {
      handler(newValue) {
        if (newValue) {
          this.initAnswers()
        }
      },
      immediate: true
    }
  },
  methods: {
    initAnswers() {
      this.subtestAnswers = {}
      if (this.tempResult) {
        try {
          const saved = JSON.parse(this.tempResult)
          this.subtestAnswers = { ...saved }
        } catch (e) {
          console.error('解析答案失败', e)
        }
      }
    },
    getOptionLetter(index) {
      return String.fromCharCode(65 + index) // A, B, C...
    },
    selectOption(subtest, optIndex) {
      const letter = this.getOptionLetter(optIndex)
      this.$set(this.subtestAnswers, subtest.id, letter)
      this.$emit('selectChange', JSON.stringify(this.subtestAnswers))
    },
    submitAnswer() {
      const allAnswered = (this.test.subtests || []).every(sub => this.subtestAnswers[sub.id])
      if (!allAnswered) {
        this.toast('请完成所有题目！');
        return
      }
      this.$emit('change', {
        result: JSON.stringify(this.subtestAnswers),
        isRight: true
      })
    },

  }
}
</script>

<style scoped>
.choice-test {
  padding: 10px;
  background: #e0eaf5;
}

.main-options {
  background: #fff;
  border: 1px solid #c9d8eb;
  padding: 15px;
  margin-bottom: 15px;
}

.option-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.options-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.option-item {
  font-size: 15px;
  color: #333;
}

.option-letter {
  font-weight: bold;
  margin-right: 5px;
}

.subtests-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.subtest-item {
  background: #fff;
  border: 1px solid #c9d8eb;
  padding: 15px;
}

.subtest-title {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 12px;
  color: #333;
}

.subtest-answer {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.answer-label {
  font-size: 14px;
  color: #333;
}

.answer-options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 5px;
}

.answer-option {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  padding: 5px 8px;
  border-radius: 4px;
  transition: background 0.2s;
}

.answer-option:hover {
  background: #f0f5fa;
}

.answer-option.active {
  background: #e6f0ff;
}

.radio-circle {
  width: 16px;
  height: 16px;
  border: 2px solid #999;
  border-radius: 50%;
  position: relative;
}

.radio-circle.checked {
  border-color: #1890ff;
}

.radio-circle.checked::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  background: #1890ff;
  border-radius: 50%;
}

.radio-letter {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.submit-btn-wrapper {
  margin-top: 20px;
  text-align: center;
}

.submit-btn {
  padding: 8px 30px;
  background: linear-gradient(#ffb740, #ff8800);
  border: 1px solid #e67600;
  color: #fff;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
